import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    UpdateProductDimentionInput,
    CreateProductDimentionInput,
    ProductDimention
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductDimentionService {
    private amplifyClient = generateClient();

    constructor() {}

    async getProductDimention(id: string): Promise<ProductDimention> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductDimention,
                    variables: {
                        id
                    }
                })
            ).data.getProductDimention;
            if (data) return data as ProductDimention;
        } catch (error) {
            console.error('Error finding ProductOptions:', error);
            return null;
        }
    }

    async createProductDimention(
        input: CreateProductDimentionInput
    ): Promise<ProductDimention> {
        try {
            const productDimention = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductDimention,
                    variables: {
                        input
                    }
                })
            ).data.createProductDimention;
            if (productDimention) return productDimention as ProductDimention;
        } catch (error) {
            console.error('Error creating productDimention:', error);
            return null;
        }
    }

    async updateProductDimention(
        input: UpdateProductDimentionInput
    ): Promise<ProductDimention> {
        try {
            const productDimention = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductDimention,
                    variables: {
                        input
                    }
                })
            ).data.updateProductDimention;
            if (productDimention) return productDimention as ProductDimention;
        } catch (error) {
            console.error('Error updating productDimention:', error);
            return null;
        }
    }
}
